import Vue from 'vue';
import VueRouter from 'vue-router';
import { Message } from 'element-ui';

Vue.use(VueRouter);

//根据js文件，自动装载路由模块
let routes = [];
const requireComponent = require.context('.', false, /\.js$/);
requireComponent.keys().forEach(fileName => {
  if (fileName !== './index.js') {
    const componentConfig = requireComponent(fileName);
    routes.push(...componentConfig.default);
  }
});

const router = new VueRouter({
  mode: 'history',
  routes
});

Vue.router = router;

//路由拦截
router.beforeEach(async (to, from, next) => {
  let sUserAgent= navigator.userAgent.toLowerCase()
  let bIsIpad= sUserAgent.match(/ipad/i) == "ipad"
  let bIsIphoneOs= sUserAgent.match(/iphone os/i) == "iphone os" 
  let bIsMidp= sUserAgent.match(/midp/i) == "midp"
  let bIsUc7= sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4"
  let bIsUc= sUserAgent.match(/ucweb/i) == "ucweb"
  let bIsAndroid= sUserAgent.match(/android/i) == "android"
  let bIsCE= sUserAgent.match(/windows ce/i) == "windows ce"
  let bIsWM= sUserAgent.match(/windows mobile/i) == "windows mobile"
  let  isChrome =  navigator.userAgent.indexOf('Chrome') > -1 
  // let  isIE =  !!window.ActiveXObject || "ActiveXObject" in window
  let  isEdge =  navigator.userAgent.indexOf("Edge") > -1
  console.log(navigator.userAgent)
  if(to.name === 'userAgent'){
    next()
  }else{
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
      Message({ type: "error", message: "请用PC端登录" }); 
    } else if (localStorage.getItem("Authorization") != null && to.name === 'login' && localStorage.getItem("xbhLiveUnionId") != null) {
      // next()
      next({ path: 'roomList', query: { unionId:localStorage.getItem("xbhLiveUnionId")}})
      // Message({ type: "error", message: "不要在同一浏览器重复登录!" }); 
    } else { 
      if(!isChrome && !isEdge) {
        next('/userAgent');
      }else{
        next();
      }
    }
  }
  
});


export default router;

export const ALL_ROUTE = routes;



// WEBPACK FOOTER //
// ./src/router/index.js